export default {
    methods: {
        startLoading(loader = 'loader') {
            this.$startLoading(loader);
        },

        endLoading(loader = 'loader') {
            this.$endLoading(loader);
        },

        onLoading(loader = 'loader') {
            return this.$isLoading(loader);
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/vuex-loading.js